const getRandomString = (length) => {
  const chars =
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

  return Array(...Array(length))
    .map(() => chars.charAt(Math.floor(Math.random() * chars.length)))
    .join('');

  // return Array.apply(null, Array(length))
  //   .map(() => chars.charAt(Math.floor(Math.random() * chars.length)))
  //   .join('');
};

export default getRandomString;
